const getInvoiceUrl = (invoice) => {
    return `https://app.fawaterk.com/invoice/${invoice.invoice_id}/${invoice.invoice_key}`;
};

const payment = {
    getInvoiceUrl,
};

export default payment;
